import { TicketSelectionApplicationData } from "@/domain/ticket-selection";

export class ApplicationTicketMaximumProvider {

    /**
     * whatItDoes
     * determines maximum tickets based on webshop and priceList settings
     */
    public static getMaximumFor(applicationData: TicketSelectionApplicationData): number {
        if (!applicationData.priceList || !applicationData.priceList.maxTicketsPerOrder) {
            return 0;
        }

        const applicationMaximum = this.getApplicationMaximum(applicationData);
        const priceListMaximum = applicationData.priceList.maxTicketsPerOrder - applicationData.cartAmount;

        return applicationMaximum <= priceListMaximum ? applicationMaximum : priceListMaximum;
    }

    /**
     * whatItDoes
     * determines maximum tickets based on webshop settings and cart contents
     */
    private static getApplicationMaximum(applicationData: TicketSelectionApplicationData): number {
        if (applicationData.eventInformation.maxTicketsCart === null) {
            return applicationData.eventInformation.maxTickets;
        }

        const cartMaximum = applicationData.eventInformation.maxTicketsCart - applicationData.cartAmount;

        return applicationData.eventInformation.maxTickets <= cartMaximum
            ? applicationData.eventInformation.maxTickets
            : cartMaximum;
    }

}
